import { gql } from "apollo-angular";
import { OrderingType } from "../../../features/administration/legal-entities/legal-entities.component";
import { RisksFilters } from "../../models/risk.model";
import { buildSearchSchema, buildStringSchema } from "../graph-ql.operations";
import { RISKS_FIELD } from "./risk.enum";
import { PagingInput, RiskQueryComplexInput, RiskQuerySimpleInput, RiskSortInput } from "../../../../../graphql/generated";

export const RISK_TABLE_QUERY = (
  page: PagingInput,
  query: RiskQueryComplexInput,
  sort: RiskSortInput,
  search?: string

) => gql`
  query GetRisksCatalogue(
    $page: PagingInput
    $query: RiskQueryComplexInput
    $sort: RiskSortInput 
) {
    riskNodesByQueryComplex(
       query: $query
        page: $page
        sort: $sort
    ) {
      ...PaginatedRiskFragment
      data {
        ...RiskTableData
      }
    }
  }
  ${PAGINATED_RISK_FRAGMENT}
  ${RISK_TABLE_FRAGMENT}
`;

export const PAGINATED_RISK_FRAGMENT = gql`
  fragment PaginatedRiskFragment on RiskQueryResponse {
    pageSize
    pageIndex
    totalPages
    totalElements
  }
`;

export const RISK_TABLE_FRAGMENT = gql`
  fragment RiskTableData on RiskNode {
    riskCode
    riskName
    riskStatus
    riskDescription
    riskExample
    category
    subNodes {
      riskCode
      riskName
      riskStatus
      riskDescription
      category
      riskExample
      subNodes {
        riskCode
        riskName
        riskStatus
        riskDescription
        category
        riskExample
      }
    }
  }
`;

export const GET_RISK_TABLE = gql`
  query {
    risk {
      ...RiskTableData
    }
  }
  ${RISK_TABLE_FRAGMENT}
`;

export const RISK_TABLE_NAMES = (...names: string[]) => gql`
  query {
    riskNodes(
      page: { pageSize: 10000000, pageNo: 0 }
    ) {
      data {
        ${names.map((name) => name.toString() + "\n")}
      }
    }
  }
`;

export const EXPORT_RISKS = (filters: RisksFilters, search: string) => gql`
  mutation exportRisks ($direction: OrderTypeInput, $sortField: RiskFields){
    downloadRiskNodesByQuery(
      query:[
          ${buildStringSchema(filters, RISKS_FIELD)}
          ${buildSearchSchema(search, ["RISK_CODE_LEVEL_ONE"]) ?? ""}
      ]
      sort:{ sortOrder: $direction , sortField: $sortField }
    ) {
      data {
        content
        filename
      }
    }
  }
`;
export const SYNCRONIZE_RISKS = () => gql`
  mutation syncronizeRisks{
    batchExecutionRiskCatalogue {
      data
      message
      statusCode
    }
  }
`;
